import { CalendarRoot } from "PFApp/booking/types/calendar_root";

export const isProjects = (
  calendarRoot: CalendarRoot
): calendarRoot is CalendarRoot.ProjectsRoles | CalendarRoot.ProjectsEngagements =>
  calendarRoot === CalendarRoot.ProjectsRoles || calendarRoot === CalendarRoot.ProjectsEngagements;

export const isWorkforceProfiles = (
  calendarRoot: CalendarRoot
): calendarRoot is CalendarRoot.WorkforceProfiles => calendarRoot === CalendarRoot.WorkforceProfiles;
